import React from 'react'
import styled from 'styled-components'
import { ICourse, ICourse2 } from '@et/types/Courses'

function CourseCardPrice (props: ICourse2) {
  const { onSale, salePrice, price, courseCard } = props
  return (
    <PriceWrapper className={`priceWrapper`}>

      {price === '0' && <Price>
        <p style={{ color: courseCard.priceColor }}>Free Course</p>
      </Price>}

      {price !== '0' && !onSale &&
      <Price>
        <NumberDisplay color={courseCard.priceColor} sale={onSale}>
          <DollarSpan>$</DollarSpan>
          <DollarAmount>{price}</DollarAmount>
        </NumberDisplay>
      </Price>}

      {price !== '0' && onSale && <Price>
        <NumberDisplay color={courseCard.priceColor} sale={onSale}>
          <DollarSpan className='dollar'>$</DollarSpan>
          <DollarAmount className='num'>{price}</DollarAmount>
        </NumberDisplay>
        <NumberDisplay color={courseCard.saleColor} sale={!onSale} className={'salePrice'}>
          <DollarSpan className='dollar'>$</DollarSpan>
          <DollarAmount className='num'>{salePrice}</DollarAmount>
        </NumberDisplay>
      </Price>}
    </PriceWrapper>
  )
}

const PriceWrapper = styled.div`
  padding: 10px 0 30px;
`
const Price = styled.div`
  font-size: 52px;
  font-weight: 400!important;
  position: relative;
  align-items: baseline;
  display: flex;
  flex-direction: row;
  justify-content: center;
  p{
    font-size: 24px;
    font-style: italic;
    font-weight: 600;
  }
`

interface INumberProps {
  sale: boolean
  color: string
}

const DollarSpan = styled.span`
  font-size: 22px;
  font-weight: 500;
  position: relative;
  left: 0;
  bottom: 0;
  top: -10px;
  align-self: center;
`
const DollarAmount = styled.span`
  position: relative;
  left: 0;
  margin-right: 0;
  bottom: 0;
  font-size: 52px;
  font-weight: 500;
  line-height: 52px;
  font-variant: lining-nums;
`
const NumberDisplay = styled.div<INumberProps>`
  padding: 0 10px;
  flex: 1;
  display: flex;
  text-align: left;
  justify-content: ${props => props.sale ? 'flex-start' : 'center'};
  color: ${props => props.color};
  span{
    color: ${props => props.color};
  }

  ${props => props.sale ? `
    ${DollarAmount}{
      text-decoration: line-through;
    } 
  ` : `
    align-self: center;
  `}
`

export default CourseCardPrice
